import { render } from 'preact'
import logo from '../public/kasualevents_logo_color.png'
function App() {
  return (
    <>
      <img src={logo} />
      <h1>Wir bauen um :)</h1>
    </>
  )
}

render(<App />, document.getElementById('app'))
